<template>
  <v-row>
    <v-col cols="12" lg="7">
      <div class="d-flex align-center mb-3">
        <div class="body-2 grey--text text--darken-2 mr-4">
          Movimientos registrados en Syscore pendientes de acreditación/débito en el banco. Pasan a la próxima conciliación.
        </div>
        <v-spacer></v-spacer>
        <v-btn small color="blue-grey" dark @click="$emit('export', 'partidas')"><v-icon left>download</v-icon> Exportar</v-btn>
      </div>
      <v-data-table :headers="headers" :items="partidas" item-key="id" hide-default-footer :items-per-page="-1" no-data-text="No hay partidas conciliatorias" class="elevation-0 bordered">
        <template v-slot:[`item.date`]="{ item }">{{ formatUtils.formatDateString(item.date) }}</template>
        <template v-slot:[`item.movimiento`]="{ item }">
          <div class="py-2">
            <div>{{ item.tipo }} · {{ item.comprobante }}</div>
            <div class="caption grey--text text--darken-1">{{ item.tercero || item.description || "" }}</div>
          </div>
        </template>
        <template v-slot:[`item.motivo`]="{ item }">
          <v-chip small color="orange lighten-5" text-color="orange darken-3">{{ item.partida.motivo.name }}</v-chip>
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          <span :class="item.amount < 0 ? 'error--text' : ''">{{ formatUtils.formatMoney(item.amount) }}</span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn v-if="editable" text small color="primary" @click="$emit('unpartida', item)">
            <v-icon left small>undo</v-icon> Volver a "A conciliar"
          </v-btn>
        </template>
      </v-data-table>
    </v-col>
    <v-col cols="12" lg="5">
      <ResumenConciliacion :summary="summary" :dateTo="dateTo" :blockers="blockers" />
    </v-col>
  </v-row>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";
import ResumenConciliacion from "./ResumenConciliacion.vue";

export default {
  components: { ResumenConciliacion },
  props: {
    partidas: { type: Array, default: () => [] },
    summary: Object,
    dateTo: String,
    blockers: { type: Array, default: () => [] },
    editable: Boolean,
  },
  data() {
    return {
      formatUtils,
      headers: [
        { text: "Fecha", value: "date" },
        { text: "Movimiento Syscore", value: "movimiento", sortable: false },
        { text: "Motivo", value: "motivo", sortable: false },
        { text: "Importe", value: "amount", align: "right" },
        { text: "", value: "actions", sortable: false, align: "right" },
      ],
    };
  },
};
</script>

<style scoped>
.bordered {
  border: 1px solid #e0e0e0;
}
</style>
